import apiInstance from 'src/apis/config/axiosConfig';
import apiInstanceNoCredential from 'src/apis/config/axiosConfigNoCredential';

// Import all the factory functions first
import {AuthServiceApiFactory} from './authService';
import {BuildingServiceApiFactory} from './buildingService';
import {MenuServiceApiFactory} from './menuService';
import {OrgServiceApiFactory} from './orgService';
import {RoleServiceApiFactory} from './roleService';
import {SiteServiceApiFactory} from './siteService';
import {UserServiceApiFactory} from './userService';
import {UserPublicServiceApiFactory} from './userPublicService';
import {ApartmentServiceApiFactory} from './apartmentService';
import {IntercomDeviceServiceApiFactory} from './intercomDeviceService';
import {AccessGroupServiceApiFactory} from './accessGroupService';
import {S3ServiceApiFactory} from './s3Service';
import {RoomServiceApiFactory} from './roomService';
import {AmenityServiceApiFactory} from './amenityService';
import {TenantServiceApiFactory} from './tenantService';
import {OrgUserServiceApiFactory} from './orgUserService';
import {UserSelfServiceApiFactory} from './userSelfService';
import {DeliveryServiceApiFactory} from './deliveryService';
import {IntercomDeviceLogServiceApiFactory} from './intercomDeviceLogService';
import {CbwDeviceServiceApiFactory} from './cbwDeviceService';
import {LicenseServiceApiFactory} from './licenseService';
import {ReservationServiceApiFactory} from './reservationService';

/* eslint-disable */
// Re-export each service individually
export {AuthServiceApiFactory} from './authService';
export {BuildingServiceApiFactory} from './buildingService';
export {MenuServiceApiFactory} from './menuService';
export {OrgServiceApiFactory} from './orgService';
export {RoleServiceApiFactory} from './roleService';
export {SiteServiceApiFactory} from './siteService';
export {UserServiceApiFactory} from './userService';
export {UserPublicServiceApiFactory} from './userPublicService';
export {ApartmentServiceApiFactory} from './apartmentService';
export {IntercomDeviceServiceApiFactory} from './intercomDeviceService';
export {AccessGroupServiceApiFactory} from './accessGroupService';
export {S3ServiceApiFactory} from './s3Service';
export {RoomServiceApiFactory} from './roomService';
export {AmenityServiceApiFactory} from './amenityService';
export {TenantServiceApiFactory} from './tenantService';
export {OrgUserServiceApiFactory} from './orgUserService';
export {UserSelfServiceApiFactory} from './userSelfService';
export {DeliveryServiceApiFactory} from './deliveryService';
export {IntercomDeviceLogServiceApiFactory} from './intercomDeviceLogService';
export {CbwDeviceServiceApiFactory} from './cbwDeviceService';
export {LicenseServiceApiFactory} from './licenseService';
export {ReservationServiceApiFactory} from './reservationService';

// Create service instances with authentication
export const authService = AuthServiceApiFactory(undefined, undefined, apiInstance);
export const buildingService = BuildingServiceApiFactory(undefined, undefined, apiInstance);
export const menuService = MenuServiceApiFactory(undefined, undefined, apiInstance);
export const orgService = OrgServiceApiFactory(undefined, undefined, apiInstance);
export const roleService = RoleServiceApiFactory(undefined, undefined, apiInstance);
export const siteService = SiteServiceApiFactory(undefined, undefined, apiInstance);
export const userService = UserServiceApiFactory(undefined, undefined, apiInstance);
export const apartmentService = ApartmentServiceApiFactory(undefined, undefined, apiInstance);
export const intercomDeviceService = IntercomDeviceServiceApiFactory(
  undefined,
  undefined,
  apiInstance
);
export const accessGroupService = AccessGroupServiceApiFactory(undefined, undefined, apiInstance);
export const s3Service = S3ServiceApiFactory(undefined, undefined, apiInstance);
export const roomService = RoomServiceApiFactory(undefined, undefined, apiInstance);
export const amenityService = AmenityServiceApiFactory(undefined, undefined, apiInstance);
export const tenantService = TenantServiceApiFactory(undefined, undefined, apiInstance);
export const orgUserService = OrgUserServiceApiFactory(undefined, undefined, apiInstance);
export const userSelfService = UserSelfServiceApiFactory(undefined, undefined, apiInstance);
export const deliveryService = DeliveryServiceApiFactory(undefined, undefined, apiInstance);
export const intercomDeviceLogService = IntercomDeviceLogServiceApiFactory(
  undefined,
  undefined,
  apiInstance
);
export const cbwDeviceService = CbwDeviceServiceApiFactory(undefined, undefined, apiInstance);
export const licenseService = LicenseServiceApiFactory(undefined, undefined, apiInstance);
export const reservationService = ReservationServiceApiFactory(undefined, undefined, apiInstance);

// Create public service instances without authentication
export const userPublicService = UserPublicServiceApiFactory(
  undefined,
  undefined,
  apiInstanceNoCredential
);

// Extract and re-export the methods
export const {
  authServiceLogin,
  authServiceLogout,
  authServiceRegisterCallback,
  authServiceResetPassword,
  authServiceSendForgetPasswordEmail,
  authServiceSendRegisterEmail,
  authServiceVerify,
  authServiceRefresh,
  authServiceAuthorize,
  authServiceAuthorizeCallback,
  authServiceAuthorizeProvider,
  authServiceDeviceLogin,
  authServiceEmailActive,
  authServiceRegister,
} = authService;

export const {
  deliveryServiceCreate,
  deliveryServiceDelete,
  deliveryServiceDetail,
  deliveryServiceFind,
  deliveryServiceUpdate,
} = deliveryService;

export const {
  buildingServiceCreate,
  buildingServiceDelete,
  buildingServiceUpdate,
  buildingServiceDetail,
  buildingServiceFind,
} = buildingService;

export const {menuServiceFindMenu} = menuService;

export const {orgServiceFind, orgServiceUpdate} = orgService;

export const {
  roleServiceBindUser,
  roleServiceCreate,
  roleServiceDelete,
  roleServiceDetail,
  roleServiceFind,
  roleServiceGetUsers,
  roleServiceInitDefault,
  roleServiceUnbindUser,
  roleServiceUpdate,
} = roleService;

export const {
  siteServiceAdd,
  siteServiceDelete,
  siteServiceFindAncestors,
  siteServiceFindDescendants,
  siteServiceList,
  siteServiceMove,
  siteServiceTree,
  siteServiceUpdate,
} = siteService;

export const {
  userServiceDelete,
  userServiceDetail,
  userServiceFind,
  userServiceUpdate,
  userServiceUpdatePassword,
  userServiceSendInvite,
  userServiceRequestOrgDeletion,
  userServiceConfirmOrgDeletion,
} = userService;

export const {
  apartmentServiceCreate,
  apartmentServiceDelete,
  apartmentServiceUpdate,
  apartmentServiceDetail,
  apartmentServiceFind,
  apartmentServiceBulkGrantPermissions,
  apartmentServiceBulkUpdatePermissions,
  apartmentServiceBulkRevokePermissions,
  apartmentServiceGetPermissions,
} = apartmentService;

export const {
  intercomDeviceServiceCreate,
  intercomDeviceServiceDelete,
  intercomDeviceServiceDetail,
  intercomDeviceServiceFind,
  intercomDeviceServiceUpdate,
  assignIntercomManager,
  unassignIntercomManager,
  editIntercomManager,
  bulkAssignIntercomManagers,
  replaceIntercomManagers,
  getDeviceModules,
  createDeviceModules,
  getAvailableModules,
  uploadDeviceLogo,
  getDeviceLogo,
  deleteDeviceLogo,
  getRoomConfig,
  updateRoomConfig,
} = intercomDeviceService;

export const {
  accessGroupServiceSave,
  accessGroupServiceDelete,
  accessGroupServiceDetail,
  accessGroupServiceFind,
  accessGroupServiceAddTenant,
  accessGroupServiceDeleteTenant,
  accessGroupServiceFindTenant,
  accessGroupServiceUpdate,
  accessGroupServiceAddOrgUser,
  accessGroupServiceAddOrgUsers,
  accessGroupServiceFindOrgUsers,
  accessGroupServiceDeleteOrgUsers,
} = accessGroupService;

export const {s3ServiceFileObject, s3ServiceGet, s3ServiceTemporarySignUrl} = s3Service;

export const {
  roomServiceCreate,
  roomServiceDelete,
  roomServiceDetail,
  roomServiceFind,
  roomServiceUpdate,
} = roomService;

export const {
  amenityServiceCreate,
  amenityServiceDelete,
  amenityServiceDetail,
  amenityServiceFind,
  amenityServiceGetAvailability,
  amenityServiceGetAvailabilityRange,
  amenityServiceUpdate,
} = amenityService;

export const {
  reservationServiceCreate,
  reservationServiceFind,
  reservationServiceDetail,
  reservationServiceCancel,
} = reservationService;

export const {
  tenantServiceCreate,
  tenantServiceDelete,
  tenantServiceDetail,
  tenantServiceFind,
  tenantServiceUpdate,
  tenantServiceSendInvite,
  tenantServiceSendInviteCallback,
  tenantServiceBulkImport,
  tenantServiceUpdateCallMethod,
  tenantServiceBatchUpdateCallMethod,
} = tenantService;

export const {
  orgUserServiceCreate,
  orgUserServiceDelete,
  orgUserServiceDetail,
  orgUserServiceFind,
  orgUserServiceSendInvite,
  orgUserServiceSendInviteCallback,
  orgUserServiceUpdate,
  orgUserServiceUpdateCallMethod,
  orgUserServiceBatchUpdateCallMethod,
} = orgUserService;

export const {
  userSelfServiceFindTenants,
  userSelfServiceLogout,
  userSelfServiceMe,
  userSelfServiceOrgFind,
  userSelfServiceWsEcho,
} = userSelfService;

export const {getIntercomDeviceAuditLogs, getMultipleDevicesStatistics, getRecentActivities} =
  intercomDeviceLogService;

// Fix: Export the guest pass function directly, not destructured
export {getGuestPassInviter} from './guestPassService';

export const {
  cbwDeviceServiceRegister,
  cbwDeviceServiceGetRegistrations,
  cbwDeviceServiceGetRegistrationStatus,
  cbwDeviceServiceGet,
  cbwDeviceServiceDelete,
  cbwDeviceServiceCreateRelayLink,
  cbwDeviceServiceSync,
  cbwDeviceServiceGetRelayLinks,
  cbwDeviceServiceUpdateRelayLink,
} = cbwDeviceService;

// Add the new public service functions
export const {userPublicServiceRegisterOrganization, userPublicServiceVerifyEmail} =
  userPublicService;

export const {
  licenseServiceRedeem,
  licenseServiceGetActive,
  licenseServiceGetAll,
  licenseServiceGetQuota,
} = licenseService;
